import { render, staticRenderFns } from "./BannerTextCreate.vue?vue&type=template&id=391b6e02&"
import script from "./BannerTextCreate.vue?vue&type=script&lang=js&"
export * from "./BannerTextCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports